var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Box" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              attrs: { inline: false, "label-position": "top" },
              model: {
                value: _vm.queryForm,
                callback: function ($$v) {
                  _vm.queryForm = $$v
                },
                expression: "queryForm",
              },
            },
            [
              _c(
                "el-row",
                {
                  staticClass: "selectClass",
                  staticStyle: { "flex-wrap": "wrap" },
                  attrs: { justify: "start", type: "flex" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("navbar.providerName") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.queryForm.params.providerId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "providerId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.providerId",
                              },
                            },
                            _vm._l(_vm.provideNameList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.providerChannelName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "collectionCenter.matchExpressWaybillStatus"
                            ),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.queryForm.params.waybillStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "waybillStatus",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.waybillStatus",
                              },
                            },
                            _vm._l(_vm.waybillStatusList, function (item, ind) {
                              return _c("el-option", {
                                key: ind,
                                attrs: { label: item.label, value: item.code },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selectTimeClass",
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.searchTimeType,
                                    callback: function ($$v) {
                                      _vm.searchTimeType = $$v
                                    },
                                    expression: "searchTimeType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: {
                                      label: _vm.$t("newOrder.createTime"),
                                      value: "1",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "default-time": ["00:00:00", "23:59:59"],
                              "end-placeholder": _vm.$t(
                                "operationCenter.endDate"
                              ),
                              format:
                                _vm.$i18n.locale === "zh"
                                  ? _vm.zhDate
                                  : _vm.ptDate,
                              "picker-options": _vm.pickerOptions,
                              "start-placeholder": _vm.$t(
                                "operationCenter.startDate"
                              ),
                              "range-separator": "~",
                              size: "small",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            on: { change: _vm.dateChange },
                            model: {
                              value: _vm.timeValue,
                              callback: function ($$v) {
                                _vm.timeValue = $$v
                              },
                              expression: "timeValue",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "collectionCenter.serviceProviderTrailDescription"
                            ),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.pleaseInput"
                              ),
                              clearable: "",
                              size: "small",
                            },
                            model: {
                              value: _vm.queryForm.params.providerTrackStatus,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "providerTrackStatus",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression:
                                "queryForm.params.providerTrackStatus",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.matchOrNot"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.queryForm.params.normal,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "normal", $$v)
                                },
                                expression: "queryForm.params.normal",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.yes"),
                                  value: 0,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.No"),
                                  value: 1,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "collectionCenter.matchExpressSubState"
                            ),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.problemTypeId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "problemTypeId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.problemTypeId",
                              },
                            },
                            _vm._l(_vm.problemList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.dictDescribe,
                                  value: item.problemId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.Search },
                },
                [_vm._v(" " + _vm._s(_vm.$t("newOrder.search")) + " ")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: { size: "small", type: "info" },
                  on: { click: _vm.resetData },
                },
                [_vm._v(" " + _vm._s(_vm.$t("orderCenterCont.reset")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { margin: "20px 0" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "success" },
              on: { click: _vm.batchMatchClick },
            },
            [_vm._v(_vm._s(_vm.$t("collectionCenter.batchMatching")) + " ")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "danger" },
              on: { click: _vm.batchEditClick },
            },
            [_vm._v(_vm._s(_vm.$t("collectionCenter.batchEdit")) + " ")]
          ),
          _c(
            "el-popover",
            {
              staticClass: "popoverClass",
              attrs: {
                content: "x",
                placement: "bottom-start",
                title: "",
                trigger: "hover",
              },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { slot: "reference", size: "small", type: "success" },
                  slot: "reference",
                },
                [_vm._v(_vm._s(_vm.$t("basicData.BulkImport")) + " ")]
              ),
              _c("div", [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { margin: "10px" },
                        attrs: { size: "small" },
                        on: { click: _vm.downloadClick },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("collectionCenter.TemplateDownload")) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { "text-align": "center" } },
                  [
                    _c(
                      "el-upload",
                      {
                        staticClass: "uploadFileClass",
                        attrs: {
                          "before-upload": _vm.beforeUpload,
                          "file-list": _vm.fileList,
                          "http-request": _vm.BulkImportClick,
                          limit: 1,
                          "show-file-list": false,
                          action: "",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          { attrs: { size: "small", type: "success" } },
                          [_vm._v(_vm._s(_vm.$t("basicData.BulkImport")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            {
              ref: "multipleRef",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, "max-height": 600, border: "" },
              on: { select: _vm.batchSelect, "select-all": _vm.batchSelect },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.ind"),
                  align: "center",
                  type: "index",
                  width: "70",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.queryForm.pageNumber - 1) *
                                _vm.queryForm.pageSize +
                                scope.$index +
                                1
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t(
                    "collectionCenter.serviceProviderTrailDescription"
                  ),
                  align: "center",
                  prop: "providerTrackStatus",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("navbar.providerName"),
                  align: "center",
                  prop: "providerName",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.matchOrNot"),
                  align: "center",
                  prop: "normal",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.normal == 0
                                  ? _vm.$t("GlobalSetObj.yes")
                                  : scope.row.normal == 1
                                  ? _vm.$t("GlobalSetObj.No")
                                  : ""
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("newOrder.createTime"),
                  align: "center",
                  prop: "createTime",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.matchingExpressDescription"),
                  align: "center",
                  prop: "expressTrackStatus",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.matchDeliveryStatusCode"),
                  align: "center",
                  prop: "expressStatus",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.matchExpressWaybillStatus"),
                  align: "center",
                  prop: "waybillStatus",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.waybillStatus
                          ? _c("div", [
                              _vm._v(_vm._s(scope.row.waybillStatusName)),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.matchExpressSubState"),
                  align: "center",
                  prop: "dictValue",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100, 500, 1000],
                  total: _vm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.Search,
                  "size-change": _vm.getPageSize,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.visible
        ? _c(
            "div",
            { staticClass: "dialogBox" },
            [
              _c(
                "el-dialog",
                {
                  attrs: {
                    "before-close": _vm.handle1Close,
                    title: _vm.dialogTitle,
                    visible: _vm.visible,
                    width: "90%",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.visible = $event
                    },
                  },
                },
                [
                  _vm._l(_vm.dialogList, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "dialogClass" },
                      [
                        _c(
                          "div",
                          { staticStyle: { width: "40%" } },
                          [
                            _c("div", { staticClass: "titleClass" }, [
                              _vm._v(
                                " " + _vm._s(_vm.$t("collectionCenter.ind"))
                              ),
                              _c("span", { staticClass: "idx" }, [
                                _vm._v(_vm._s(index + 1)),
                              ]),
                            ]),
                            _c(
                              "el-descriptions",
                              {
                                staticStyle: { "margin-left": "48px" },
                                attrs: {
                                  column: 2,
                                  border: "",
                                  direction: "vertical",
                                },
                              },
                              [
                                _c(
                                  "el-descriptions-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "collectionCenter.serviceProviderTrailDescription"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.providerTrackStatus) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "el-icon-right rightIcon" }),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "40%",
                              "margin-right": "48px",
                            },
                          },
                          [
                            _c("div", { staticClass: "titleClass" }, [
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("*"),
                              ]),
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "collectionCenter.waybillStatusMatches"
                                  )
                                ) + " "
                              ),
                            ]),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "collectionCenter.pleaseFindOrSelectWaybillStatus"
                                  ),
                                  clearable: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeWbs(
                                      item.waybillStatus,
                                      index
                                    )
                                  },
                                },
                                model: {
                                  value: item.waybillStatus,
                                  callback: function ($$v) {
                                    _vm.$set(item, "waybillStatus", $$v)
                                  },
                                  expression: "item.waybillStatus",
                                },
                              },
                              _vm._l(
                                _vm.waybillStatusList,
                                function (item, ind) {
                                  return _c("el-option", {
                                    key: ind,
                                    attrs: {
                                      label: item.label,
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                            item.waybillStatus == 11
                              ? _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "collectionCenter.pleaseChoose"
                                      ),
                                      clearable: "",
                                      filterable: "",
                                    },
                                    model: {
                                      value: item.problemTypeId,
                                      callback: function ($$v) {
                                        _vm.$set(item, "problemTypeId", $$v)
                                      },
                                      expression: "item.problemTypeId",
                                    },
                                  },
                                  _vm._l(
                                    _vm.problemList,
                                    function (itm, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: itm.dictDescribe,
                                          value: itm.problemId,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveClick },
                        },
                        [_vm._v(_vm._s(_vm.$t("collectionCenter.Save")))]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.visibleImport
        ? _c(
            "div",
            [
              _c(
                "el-dialog",
                {
                  attrs: {
                    "before-close": _vm.handle2Close,
                    title: _vm.$t("spareNumberPoo.ImportData"),
                    visible: _vm.visibleImport,
                    width: "90%",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.visibleImport = $event
                    },
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.importData,
                        "max-height": 600,
                        "row-style": _vm.tableRowStyle,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "collectionCenter.serviceProviderTrailDescription"
                          ),
                          align: "center",
                          prop: "providerTrackStatus",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("navbar.providerName"),
                          align: "center",
                          prop: "providerName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }